import { Link, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/auth'

export default function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const { logout, email, username, creditsBalance } = useAuthStore()

  const navItems = [
    { path: '/jobs', label: 'Jobs' },
    { path: '/calendar', label: 'Calendar' },
    { path: '/settings', label: 'Settings' },
  ]

  // Display name: prefer username, then email prefix, fallback to 'User'
  const displayName = username || (email ? email.split('@')[0] : null)

  // Generate avatar initials
  const initials = displayName
    ? displayName.slice(0, 2).toUpperCase()
    : 'U'

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-between items-center h-14">
            <Link to="/jobs" className="flex items-center gap-2 font-semibold text-gray-900">
              <span className="text-lg">📸</span>
              Daily Instagram Story
            </Link>

            <nav className="flex items-center gap-6">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm ${
                    location.pathname.startsWith(item.path)
                      ? 'text-indigo-600 font-medium'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {item.label}
                </Link>
              ))}

              {/* User info section */}
              <div className="flex items-center gap-3 pl-4 border-l border-gray-200">
                {creditsBalance !== null && (
                  <span className="text-xs text-gray-500">
                    {creditsBalance.toLocaleString()} credits
                  </span>
                )}

                <div className="flex items-center gap-2">
                  {/* Avatar */}
                  <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-xs font-medium">
                    {initials}
                  </div>

                  {/* Display name/email */}
                  {displayName && (
                    <span className="text-sm text-gray-700 max-w-[120px] truncate">
                      {displayName}
                    </span>
                  )}
                </div>

                <button
                  onClick={logout}
                  className="text-sm text-gray-500 hover:text-gray-700"
                >
                  Logout
                </button>
              </div>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>{children}</main>
    </div>
  )
}
